import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import { AxiosResponse } from 'axios';
import { put, takeLatest } from 'redux-saga/effects';
import { handleError } from 'redux/saga/utils/errorUtils';
import {
  fetchAreaFilter,
  fetchAreaFilterFailure,
  fetchAreaFilterSuccess,
  fetchCityFilter,
  fetchCityFilterFailure,
  fetchCityFilterSuccess,
  fetchMyAgencies,
  fetchMyAgenciesFailure,
  fetchMyAgenciesSuccess,
  fetchPincodeFilter,
  fetchPincodeFilterFailure,
  fetchPincodeFilterSuccess,
} from 'redux/slice/compliance/agency/Agency.slice';
import {
  IComplianceFilterRequest,
  IComplianceFilterResponse,
  IGetAgenciesRequest,
  IGetAgenciesResponse,
} from 'redux/types/compliance/Agency.types';
import { complianceEndPoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

function* handleFetchMyAgenciesSaga(
  action: PayloadAction<IGetAgenciesRequest>
) {
  try {
    const { allocatorId, ...requestBody } = action.payload;
    const endpoint = complianceEndPoints.GET_AGENCIES(allocatorId);
    const response: AxiosResponse<IGetAgenciesResponse> =
      yield HTTPClient.PostRequest(endpoint, requestBody);
    yield put(fetchMyAgenciesSuccess(response.data));
    message.success(response.data.message);
  } catch (error: any) {
    yield* handleError(error, fetchMyAgenciesFailure, '');
  }
}
function* handleFetchPincodeFilterSaga(
  action: PayloadAction<IComplianceFilterRequest>
) {
  const { allocatorId } = action.payload;
  try {
    const endpoint = complianceEndPoints.GET_PINCODES(allocatorId);
    const response: AxiosResponse<IComplianceFilterResponse> =
      yield HTTPClient.GetRequest(endpoint);
    yield put(fetchPincodeFilterSuccess(response.data));
  } catch (error: any) {
    yield* handleError(
      error,
      fetchPincodeFilterFailure,
      'Failed to fetch pincode filters'
    );
  }
}
function* handleFetchCityFilterSaga(
  action: PayloadAction<IComplianceFilterRequest>
) {
  const { allocatorId } = action.payload;

  try {
    const endpoint = complianceEndPoints.GET_CITIES(allocatorId);
    const response: AxiosResponse<IComplianceFilterResponse> =
      yield HTTPClient.GetRequest(endpoint);
    yield put(fetchCityFilterSuccess(response.data));
  } catch (error: any) {
    yield* handleError(
      error,
      fetchCityFilterFailure,
      'Failed to fetch city filters'
    );
  }
}
function* handleFetchAreaFilterSaga(
  action: PayloadAction<IComplianceFilterRequest>
) {
  const { allocatorId } = action.payload;

  try {
    const endpoint = complianceEndPoints.GET_AREAS(allocatorId);
    const response: AxiosResponse<IComplianceFilterResponse> =
      yield HTTPClient.GetRequest(endpoint);
    yield put(fetchAreaFilterSuccess(response.data));
  } catch (error: any) {
    yield* handleError(
      error,
      fetchAreaFilterFailure,
      'Failed to fetch area filters'
    );
  }
}
export function* watchAgencySaga() {
  yield takeLatest(fetchMyAgencies.type, handleFetchMyAgenciesSaga);
  yield takeLatest(fetchPincodeFilter.type, handleFetchPincodeFilterSaga);
  yield takeLatest(fetchCityFilter.type, handleFetchCityFilterSaga);
  yield takeLatest(fetchAreaFilter.type, handleFetchAreaFilterSaga);
}
